export const en = {
  // Nav
  'nav.home': 'Dashboard',
  'nav.practice': 'Practice',
  'nav.history': 'History',
  'nav.bookmarks': 'Bookmarks',
  'nav.wrongQuestions': 'Wrong Questions',
  'nav.admin': 'Admin',
  'nav.logout': 'Logout',
  'nav.login': 'Login',
  'nav.register': 'Register',

  // Auth
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.displayName': 'Display Name',
  'auth.login': 'Sign In',
  'auth.register': 'Create Account',
  'auth.loginPrompt': 'Already have an account?',
  'auth.registerPrompt': 'Don\'t have an account?',
  'auth.loginLink': 'Sign in',
  'auth.registerLink': 'Create one',

  // Dashboard
  'dash.welcome': 'Welcome back',
  'dash.totalAttempts': 'Total Quizzes',
  'dash.completed': 'Completed',
  'dash.avgScore': 'Average Score',
  'dash.mastery': 'Mastery Overview',
  'dash.mastered': 'Mastered',
  'dash.review': 'Review',
  'dash.learning': 'Learning',
  'dash.unseen': 'Unseen',
  'dash.recentAttempts': 'Recent Quizzes',
  'dash.weakAreas': 'Weak Areas',
  'dash.progress': 'Progress by Paper',
  'dash.startPractice': 'Start Practice',

  // Catalog
  'catalog.title': 'Practice Questions',
  'catalog.selectPaper': 'Select Paper',
  'catalog.selectTopic': 'Select Topic',
  'catalog.selectChapter': 'Select Chapter',
  'catalog.questionsAvailable': 'questions available',
  'catalog.startQuiz': 'Start Quiz',
  'catalog.questionCount': 'Number of Questions',
  'catalog.mode': 'Mode',
  'catalog.paper': 'Full Paper',
  'catalog.topic': 'By Topic',
  'catalog.chapter': 'By Chapter',
  'catalog.mock': 'Mock Exam (40 Questions)',
  'catalog.random': 'Random Mix',

  // Quiz
  'quiz.question': 'Question',
  'quiz.of': 'of',
  'quiz.submit': 'Submit Quiz',
  'quiz.next': 'Next',
  'quiz.prev': 'Previous',
  'quiz.finish': 'Finish & Review',
  'quiz.bookmark': 'Bookmark',
  'quiz.unbookmark': 'Remove Bookmark',
  'quiz.timeElapsed': 'Time',
  'quiz.answered': 'Answered',
  'quiz.confirmSubmit': 'Are you sure you want to submit? You have {count} unanswered questions.',
  'quiz.confirmAbandon': 'Are you sure you want to abandon this quiz?',
  'quiz.abandon': 'Abandon',

  // Results
  'result.title': 'Quiz Results',
  'result.score': 'Score',
  'result.correct': 'Correct',
  'result.incorrect': 'Incorrect',
  'result.unanswered': 'Unanswered',
  'result.time': 'Time Taken',
  'result.review': 'Review Answers',
  'result.retake': 'Retake',
  'result.backToDash': 'Back to Dashboard',
  'result.explanation': 'Explanation',
  'result.yourAnswer': 'Your Answer',
  'result.correctAnswer': 'Correct Answer',

  // History
  'history.title': 'Quiz History',
  'history.noAttempts': 'No quizzes taken yet',
  'history.mode': 'Mode',
  'history.score': 'Score',
  'history.questions': 'Questions',
  'history.date': 'Date',
  'history.duration': 'Duration',
  'history.status': 'Status',
  'history.view': 'View',

  // Bookmarks
  'bookmarks.title': 'Bookmarked Questions',
  'bookmarks.empty': 'No bookmarks yet',
  'bookmarks.remove': 'Remove',

  // Wrong Questions
  'wrong.title': 'Wrong Questions Review',
  'wrong.empty': 'No wrong questions - great job!',
  'wrong.reviewAll': 'Review All Wrong Questions',
  'wrong.filter': 'Filter by Paper',
  'wrong.attempts': 'Attempts',
  'wrong.correctRate': 'Correct Rate',

  // Admin
  'admin.dashboard': 'Admin Dashboard',
  'admin.questions': 'Manage Questions',
  'admin.users': 'Manage Users',
  'admin.import': 'Import / Export',
  'admin.stats': 'Statistics',
  'admin.totalUsers': 'Total Users',
  'admin.totalQuestions': 'Total Questions',
  'admin.totalAttempts': 'Total Quizzes',
  'admin.avgScore': 'Platform Avg Score',
  'admin.search': 'Search...',
  'admin.create': 'Create',
  'admin.edit': 'Edit',
  'admin.save': 'Save',
  'admin.cancel': 'Cancel',
  'admin.delete': 'Delete',
  'admin.status': 'Status',
  'admin.role': 'Role',
  'admin.actions': 'Actions',

  // Common
  'common.loading': 'Loading...',
  'common.error': 'Something went wrong',
  'common.retry': 'Retry',
  'common.noData': 'No data',
  'common.page': 'Page',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.all': 'All',
  'common.language': 'Language',
  'common.english': 'English',
  'common.chinese': '中文',
  'common.bilingual': 'Bilingual',
}
